import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Box from '@material-ui/core/Box'

import Close from '@material-ui/icons/Close'

import React, { useContext, useEffect, useState } from 'react'
import CustomButton from '../../CustomButton'
import CustomHeading from '../../CustomHeading'
import CustomInput from '../../CustomInput'
import { useZone } from '../../../hooks/CompanyConfiguration/useZone'
import { useLocation } from '../../../hooks/Location/useLocation'
import CustomSelect from '../../CustomSelect'

export const ZonesCatalogue = ({ handleClose }) => {
  const [region, setRegion] = useState('')
  const [zoneName, setZoneName] = useState('')
  const { addZone } = useZone()
  const { regions, getAllRegion } = useLocation()

  useEffect(() => {
    getAllRegion()
  }, [])

  const handleAddZone = () => {
    addZone({ name: zoneName, region })
    handleClose()
    setZoneName('')
    setRegion('')
  }
  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <CustomHeading heading={'Add Zone'} />
        <IconButton color="inherit" onClick={handleClose} size="small">
          <Close />
        </IconButton>
      </Box>
      <br />
      <Grid container>
        <Grid item lg={12}>
          <CustomSelect options={regions} label="Region *" value={region} handleChange={setRegion} />
        </Grid>
        <Grid item lg={12}>
          <br />

          <CustomInput label={'Zone'} value={zoneName} handleChange={setZoneName} />
        </Grid>
        <Grid item lg={12}>
          <br />
          <CustomButton text={'Add'} handleSubmit={handleAddZone} />
        </Grid>
      </Grid>
    </>
  )
}
